import { render, staticRenderFns } from "./RecordList.vue?vue&type=template&id=ba2b07dc&scoped=true"
import script from "./RecordList.vue?vue&type=script&lang=js"
export * from "./RecordList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba2b07dc",
  null
  
)

export default component.exports